import VrRetail from "./VrRetail.container";

export default VrRetail;
